export type SDGNumber = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17;

export type SDG = {
  title: string;
  description: string;
  goalNumber: SDGNumber;
};

export const SDGs: readonly SDG[] = [
  {
    description: 'End poverty in all its forms everywhere',
    goalNumber: 1,
    title: 'No Poverty',
  },
  {
    description: 'End hunger, achieve food security and improved nutrition and promote sustainable agriculture',
    goalNumber: 2,
    title: 'Zero Hunger',
  },
  {
    description: 'Ensure healthy lives and promote well-being for all at all ages',
    goalNumber: 3,
    title: 'Good Health and Well-being',
  },
  {
    description: 'Ensure inclusive and equitable quality education and promote lifelong learning opportunities for all',
    goalNumber: 4,
    title: 'Quality Education',
  },
  {
    description: 'Achieve gender equality and empower all women and girls',
    goalNumber: 5,
    title: 'Gender Equality',
  },
  {
    description: 'Ensure availability and sustainable management of water and sanitation for all',
    goalNumber: 6,
    title: 'Clean Water and Sanitation',
  },
  {
    description: 'Ensure access to affordable, reliable, sustainable and modern energy for all',
    goalNumber: 7,
    title: 'Affordable and Clean Energy',
  },
  {
    description:
      'Promote sustained, inclusive and sustainable economic growth, full and productive employment and decent work for all',
    goalNumber: 8,
    title: 'Decent Work and Economic Growth',
  },
  {
    description:
      'Build resilient infrastructure, promote inclusive and sustainable industrialization and foster innovation',
    goalNumber: 9,
    title: 'Industry, Innovation and Infrastructure',
  },
  {
    description: 'Reduce inequality within and among countries',
    goalNumber: 10,
    title: 'Reduced Inequality',
  },
  {
    description: 'Make cities and human settlements inclusive, safe, resilient and sustainable',
    goalNumber: 11,
    title: 'Sustainable Cities and Communities',
  },
  {
    description: 'Ensure sustainable consumption and production patterns',
    goalNumber: 12,
    title: 'Responsible Consumption and Production',
  },
  {
    description: 'Take urgent action to combat climate change and its impacts*',
    goalNumber: 13,
    title: 'Climate Action',
  },
  {
    description: 'Conserve and sustainably use the oceans, seas and marine resources for sustainable development',
    goalNumber: 14,
    title: 'Life Below Water',
  },
  {
    description:
      'Protect, restore and promote sustainable use of terrestrial ecosystems, sustainably manage forests, combat desertification, and halt and reverse land degradation and halt biodiversity loss',
    goalNumber: 15,
    title: 'Life on Land',
  },
  {
    description:
      'Promote peaceful and inclusive societies for sustainable development, provide access to justice for all and build effective, accountable and inclusive institutions at all levels',
    goalNumber: 16,
    title: 'Peace and Justice Strong Institutions',
  },
  {
    description:
      'Strengthen the means of implementation and revitalize the global partnership for sustainable development',
    goalNumber: 17,
    title: 'Partnerships to achieve the Goal',
  },
] as const;

export const SDGNumberToSDG: Record<SDGNumber, SDG> = SDGs.reduce(
  (acc, sdg) => ({ ...acc, [sdg.goalNumber]: sdg }),
  {} as Record<SDGNumber, SDG>,
);
